import { addModal } from 'weblite-web-modal-viewer'
import { ImageViewerModal } from './image-viewer-modal'

const COMPONENT_ID = 'imageViewer'

export const showImageViewerModal = (
  props: Parameters<typeof ImageViewerModal>[0],
) => addModal({ id: COMPONENT_ID, closeImmediately: true, props })

export default {
  [COMPONENT_ID]: {
    Component: ImageViewerModal,
  },
}
